import "core-js/modules/es.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getDataJson, pollingRefresh } from "@/utils/refreshCptData";
export default {
  name: "cpt-rect-num",
  inject: ['queryParam'],
  props: {
    option: Object,
    height: Number
  },
  data: function data() {
    return {
      cptData: {
        value: '12345'
      },
      uuid: null
    };
  },
  created: function created() {
    this.uuid = require('uuid').v1();
    this.refreshCptData();
  },
  methods: {
    refreshCptData: function refreshCptData() {
      pollingRefresh(this.uuid, this.option.cptDataForm, this.loadData);
    },
    loadData: function loadData() {
      var _this = this;

      getDataJson(this.option.cptDataForm, this.queryParam, "RectNum").then(function (res) {
        _this.cptData = res;
      });
    }
  }
};